import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.get({
      url: '/la/admin/c2c/order/list',
      data
    });
  },
  approveAudit(data) {
    return http.post({
      url: '/la/admin/c2c/audit',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  rejectAudit(data) {
    return http.post({
      url: '/la/admin/c2c/reject',
      data,
      dataType: 'form'
    });
  },
  getAllList(data) {
    return http.get({
      url: '/la/admin/c2c/order/all',
      data
    });
  }
};
